import basicplans from "./basicplans.component";
import basicplansUrls from "./basicplans.urls";
import BasicplansTransforms from "./basicplans.transforms";

const basicplansModule = angular
  .module("app.components.basicplans", [])
  .component("basicplansPage", basicplans)
  .service("BasicplansTransforms", BasicplansTransforms)
  .config(basicplansUrls);

export default basicplansModule;



// WEBPACK FOOTER //
// ./src/pages/basicplans/basicplans.module.js